import { EWhatsAppTransportType } from "./EWhatsAppTransportType"
import { IPlatformWhatsAppOverview } from "./IPlatformWhatsAppOverview"
import { IPlatformWhatsAppSettings } from "./IPlatformWhatsAppSettings"

export const emptyPlatformWhatsAppOverview = (): IPlatformWhatsAppOverview => ({
  agents: [],
  openConversations: 0,
  awaitingHuman: 0,
  qualifiedLeads: 0,
  wonLeads: 0,
  inboundMessagesToday: 0,
  isBotEnabled: false,
})

export const emptyPlatformWhatsAppSettings = (): IPlatformWhatsAppSettings => ({
  isEnabled: true,
  provider: 0,
  endpointUrl: "https://api.openai.com/v1/chat/completions",
  model: "gpt-4o-mini",
  apiKey: "",
  hasApiKey: false,
  botDisplayName: "",
  personality: "",
  additionalInstructions: "",
  humanHandoffKeywords: "",
  maximumReplyCharacters: 1800,
  signupUrl: "",
  tutorialsUrl: "",
  knowledgeVersion: 0,
  activeTransport: EWhatsAppTransportType.DesktopAgent,
  whatsAppSaaSInstanceId: null,
  whatsAppSaaSBaseUrl: "",
  whatsAppSaaSApiKey: "",
  hasWhatsAppSaaSApiKey: false,
  whatsAppSaaSWebhookSecret: "",
  hasWhatsAppSaaSWebhookSecret: false,
})
